import { SharedModule } from '@@shared/shared.module'
import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'

@Component({
    standalone: true,
    imports: [SharedModule, CommonModule, RouterModule, TranslateModule],
    selector: 'in-portal-footer',
    templateUrl: './portal-footer.component.html',
    styleUrls: ['./portal-footer.component.css']
})
export class PortalFooterComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
